// @flow
/* eslint-disable no-underscore-dangle */
import type {
  Worklog,
} from '../../types';
import {
  stj,
} from '../time-util';

export function getWorklogType(worklog: Worklog): string {
  if (worklog.typeMixed) {
    return 'mixed';
  } else if (worklog.auto && worklog.diff < 60) {
    return 'automatic';
  } else if (worklog.temporary) {
    return 'in-progress';
  } else if (!worklog.auto) {
    return 'manual';
  }
  throw new Error('Cannot determine worklog type');
}

export function getTimeSpentSeconds(worklog: Worklog): number {
  const isGroup =
    worklog.__type === 'worklogGroup' ||
    (worklog.worklogs && worklog.worklogs.length > 0);

  return isGroup
    ? worklog.worklogs.reduce((result, w) => (result + w.timeSpentSeconds || 0), 0)
    : worklog.timeSpentSeconds;
}

export function getTotalTimeLogged(worklog: Worklog): string {
  return stj(getTimeSpentSeconds(worklog));
}
